import * as React from "react";
import {
  Label,
  Caption1,
  Combobox,
  Option,
  tokens,
} from "@fluentui/react-components";
import { ServiceType } from "../../../../contexts/SettingsContext";
import { FEATURE_FLAGS } from "../../../../config/featureFlags";

interface ServiceSelectorProps {
  label: string;
  description: string;
  openAILabel: string;
  azureLabel: string;
  openAICompatibleLabel: string;
  anthropicLabel: string;
  bedrockLabel: string;
  bedrockAgentCoreLabel: string;
  selectedService: ServiceType;
  onServiceChange: (service: ServiceType) => void;
}

const ServiceSelector: React.FC<ServiceSelectorProps> = ({
  label,
  description,
  openAILabel,
  azureLabel,
  openAICompatibleLabel,
  anthropicLabel,
  bedrockLabel,
  bedrockAgentCoreLabel,
  selectedService,
  onServiceChange,
}) => {
  const serviceOptions = [
    { value: 'openai', label: openAILabel },
    { value: 'azure', label: azureLabel },
    { value: 'openai-compatible', label: openAICompatibleLabel },
    ...(FEATURE_FLAGS.anthropic ? [{ value: 'anthropic', label: anthropicLabel }] : []),
    ...(FEATURE_FLAGS.bedrock ? [{ value: 'bedrock', label: bedrockLabel }] : []),
    ...(FEATURE_FLAGS.bedrockAgentCore ? [{ value: 'bedrock-agentcore', label: bedrockAgentCoreLabel }] : []),
  ];

  const selectedServiceLabel = serviceOptions.find(opt => opt.value === selectedService)?.label || '';

  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ marginBottom: '8px' }}>
        <Label htmlFor="service">{label}</Label>
        <div style={{ marginTop: '2px' }}>
          <Caption1 style={{ color: tokens.colorNeutralForeground3 }}>
            {description}
          </Caption1>
        </div>
      </div>
      <Combobox
        id="service"
        value={selectedServiceLabel}
        selectedOptions={[selectedService]}
        onOptionSelect={(_, data) => onServiceChange(data.optionValue as ServiceType)}
        style={{ width: '100%' }}
      >
        {serviceOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Combobox>
    </div>
  );
};

export default ServiceSelector;